import axios from 'axios'
import env from '../env'

export default class LocationAPI {
  static async getCnAreaCodeByName (params: {
    cityName?: string;
    provinceName?: string;
    countyName?: string;
  }) {
    const url: string = `${env.JMOBILE}/city/getCnAreaCodeByName`
    const res: any = await axios.post(url, params)
    return res.error ? res : res.result
  }
  static async getCityInGoogle (params: {
    lat: number;
    lng: number;
  }) {
    const url: string = `https://geoservice.eshine.us/googlemap/place/nearbysearch?location=${params.lat},${params.lng}&radius=1500`
    const res: any = await axios.get(url)
    return res.error ? res : res.results
  }
}
